module.exports = __webpack_public_path__ + "static/media/ic_agenda.0f79c54c.svg";